module.exports = __webpack_public_path__ + "img/twitter-icon1.e62aa0e8.png";